import app from "../_app";
import {updateCartCount} from "./microcart";

const combinationDeals = document.querySelector('#bundler-target-element');

if (combinationDeals) {
    document.addEventListener('bundler:bundle_widget_created', function(e) {
        const html =
            '<h3 class="heading NIKE large strong pdp--heading-spacer">' + app.translationHelper("combinationsTitle") + '</h3>';

        combinationDeals.insertAdjacentHTML('beforebegin', html);
    });

    document.addEventListener('product:added', function() {
        updateCartCount();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

    });

}
